import { AdContent } from "@core/models/ad-content.model";
import { Style } from "@core/models/style.model";
import { MultiFieldEditorContent } from '@app/order/models/multi-field-editor-content';

export class ContentViewModel {
	style?: Style;

	adText?: string;
	multiFieldEditorContent?: MultiFieldEditorContent;

	adContentCache?: AdContent[];
	preview?: string;
}
